import { jsx as _jsx } from "react/jsx-runtime";
import { BACKDROP_DEFAULT, getOverlayClassName, } from '#pplx/frontend/aether/components/Modal/internal/ModalInternals.js';
import { useRadixProps } from '#pplx/frontend/aether/internal/useRadixProps.js';
import { animated, SpringValue } from '@react-spring/web';
export function ModalBackdrop({ opacity, zIndexStyle, style, isVisible = true, variant = BACKDROP_DEFAULT, ...props }) {
    const shouldApplyBlur = isVisible && variant !== 'side-sheet' && variant !== 'transparent';
    const blur = variant === 'frosted' ? 'blur(16px)' : 'blur(4px)';
    const __radixProps = useRadixProps(props);
    return (_jsx(animated.div, { ...__radixProps, className: getOverlayClassName({ variant }), style: {
            ...style,
            ...zIndexStyle,
            opacity: isVisible ? opacity : 0,
            // Keep the filtered backdrop stable while only its composited opacity
            // animates. Interpolating backdrop-filter repaints the whole viewport
            // on every spring frame and stalls easily when a heavy dialog mounts.
            backdropFilter: shouldApplyBlur ? blur : undefined,
            WebkitBackdropFilter: shouldApplyBlur ? blur : undefined,
            willChange: 'opacity',
        }, children: variant === 'frosted' && _jsx("div", { className: "absolute inset-0 bg-base opacity-70" }) }));
}
//# sourceMappingURL=ModalBackdrop.js.map